import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/runner/work/tiagoj.co/tiagoj.co/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineComponent, ref, reactive } from "vue";
import { useI18n } from "vue-i18n";
import { formatDistance, parse } from "date-fns";
import { ptBR, enUS } from "date-fns/locale";
import get from "axios";
var twitterTimelineApi = "https://us-central1-tiagoj-co.cloudfunctions.net/twitter-lite-proxy";
export default defineComponent({
  name: "TwitterTimeline",
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _useI18n, t, locale, user, tweets;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _useI18n = useI18n(), t = _useI18n.t, locale = _useI18n.locale;
              user = ref({});
              tweets = reactive([ref(0)]); // query timeline api

              _context.next = 5;
              return get(twitterTimelineApi).then(function (response) {
                // handle success
                tweets = response.data.map(function (tweetRaw) {
                  var tweet = tweetRaw.retweeted_status || tweetRaw;
                  tweet.rt = tweet.id_str === tweetRaw.id_str ? null : tweetRaw.user.name;
                  user = tweetRaw.user;
                  return tweet;
                });
              }).catch(function (error) {
                // handle error
                console.error(error);
              }).then(function () {
                // always executed
                console.info("twitter tweets done.");
              });

            case 5:
              return _context.abrupt("return", {
                user: user,
                tweets: tweets,
                t: t,
                locale: locale,
                fromNow: function fromNow(relativeDate) {
                  var l = locale.value == "pt-br" ? ptBR : enUS; // Sun May 10 12:02:50 +0000 2020

                  return formatDistance(parse(relativeDate, "EEE MMM d HH:mm:ss XXXX yyyy", new Date()), new Date(), {
                    locale: l
                  });
                }
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }
});